import { render, staticRenderFns } from "./Infowidget.vue?vue&type=template&id=32200fa7"
import script from "./Infowidget.vue?vue&type=script&lang=js"
export * from "./Infowidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports